import clsx from 'clsx';
import { Base } from '../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "effect": "Placeholder-effect_1YLEe",
  "move": "Placeholder-move_3_r_P",
  "root": "Placeholder-root_G1eL2 Placeholder-effect_1YLEe"
};
function Placeholder({
  chars = 3,
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    tagName: "span",
    style: {
      minWidth: `${chars}ch`
    },
    className: clsx(styles.root, className),
    ...extraProps
  });
}
export default Placeholder;